<template>
  <Teleport to="body">
    <div class="d-flex justify-content-center">
      <div class="mb-3 p-2 px-md-4 rounded shadow d-flex justify-content-between align-items-center nav">
        <div class="">
          <a href="#home" class="text-decoration-none text-black"><i class="bi bi-house h2"></i></a>
        </div>
        <div>
          <a href="#about" class="text-decoration-none text-black"><i class="bi bi-file-person h2"></i></a>
        </div>
        <div>
          <a href="#path" class="text-decoration-none text-black"><i class="bi bi-layers-half h2"></i></a>
        </div>
        <div>
          <a href="#projects" class="text-decoration-none text-black"><i class="bi bi-clock-history h2"></i></a>
        </div>
        <div>
          <a href="#colab" class="text-decoration-none text-black"><i class="bi bi-envelope-heart h2"></i></a>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style scoped></style>
